/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Remplace intégralement la liste des branches de l'indice — elle n'est pas enrichie. Transmettre la liste complète voulue : toute branche absente est détachée.
 * @export
 * @interface RattacherBranchesIndiceCommand
 */
export interface RattacherBranchesIndiceCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof RattacherBranchesIndiceCommand
     */
    branchIds?: Array<string>;
}

/**
 * Check if a given object implements the RattacherBranchesIndiceCommand interface.
 */
export function instanceOfRattacherBranchesIndiceCommand(value: object): value is RattacherBranchesIndiceCommand {
    return true;
}

export function RattacherBranchesIndiceCommandFromJSON(json: any): RattacherBranchesIndiceCommand {
    return RattacherBranchesIndiceCommandFromJSONTyped(json, false);
}

export function RattacherBranchesIndiceCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): RattacherBranchesIndiceCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'branchIds': json['branchIds'] == null ? undefined : json['branchIds'],
    };
}

export function RattacherBranchesIndiceCommandToJSON(json: any): RattacherBranchesIndiceCommand {
    return RattacherBranchesIndiceCommandToJSONTyped(json, false);
}

export function RattacherBranchesIndiceCommandToJSONTyped(value?: RattacherBranchesIndiceCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchIds': value['branchIds'],
    };
}

